import {AsyncState} from "../components/AsyncState";

export function NotFound() {
  return <AsyncState kind="empty" detail="No Software Factory route matches this URL. The requested object was not inferred or replaced with a fixture."
    action={<a className="button-link" href="/dashboard">Return to Dashboard</a>} />;
}
